import { useEffect, useState } from 'react';
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import { ProfileVisibilityTypeEnum } from '../../enums/ProfileVisibilityTypeEnum';
import './PublicProfilePage.scss';
import { useParams } from 'react-router-dom';
import { Buyer } from '../../Models/Buyer';
import { BuyerAPIHandler } from '../../services/NetworkClient/BackendAPIs/BuyerAPIHandler';
import GGLoaderView from '../../components/UtilityComponents/GGLoaderView/GGLoaderView';
import BuyerProfileDetailsSection from '../../components/PageComponents/ProfileDetailsPageComponents/BuyerProfileDetailsSection/BuyerProfileDetailsSection';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';
import SellerProfileDetailsSection from '../../components/PageComponents/ProfileDetailsPageComponents/SellerProfileDetailsSection/SellerProfileDetailsSection';

const PublicProfilePage = () => {

  const { id } = useParams();
  const [buyer, setBuyer] = useState<Buyer | undefined>(undefined)
  const [showLoader, setShowLoader] = useState(true)

  useEffect(() => {
    document.title = "GenieGig | Profile";
    window.scrollTo(0, 0);
    logAnalyticsEvent(GGAnalyticsEvents.PUBLIC_PROFILE_PAGE_LOADED);

    const getUserData = async () => {
      try {
        let buyer = await BuyerAPIHandler.shared.getBuyerPublicById(id ?? "");
        document.title = "GenieGig | " + buyer.fullName;
        setBuyer(buyer)
        setShowLoader(false)
      } catch (err) {
        setShowLoader(false)
      }
    }

    getUserData()
  // eslint-disable-next-line
  }, [])


  return (
    <div>
      {showLoader && <GGLoaderView />}
      <Navbar useScrollVersion={true} />

      {buyer?.seller !== undefined ? (
        <SellerProfileDetailsSection sellerId={buyer.seller} visibility={ProfileVisibilityTypeEnum.PublicProfile} />
      ) : (
        buyer && <BuyerProfileDetailsSection buyerObject={buyer} visibility={ProfileVisibilityTypeEnum.PublicProfile} />
      )}
      <Footer />
    </div>

  )
}

export default PublicProfilePage